/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./search.vue?vue&type=template&id=3390d147&"
import script from "./search.vue?vue&type=script&setup=true&lang=ts&"
export * from "./search.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports